// extracted by mini-css-extract-plugin
export default {"issueDescription":"Jn6hl4TU3JEHa2uP_occ","issueDescriptionTitle":"yozLGq59GnT8W8WU2u6Q","issueDescriptionContent":"Ibz8qwXfv7rjl9JymXQp"};